{
    "translation": {
        "button": {
            "ok": "Ok",
            "cancel": "Cancellare",
            "login": "Login",
            "logout": "Logout",
            "save": "Salva",
            "manageoptions": "ManageOptions",
            "manageproduct": "Gestisci prodotto",
            "resetAll": "Reimposta tutto sui valori del prodotto",
            "revert": "Ripristina",
            "statusButton": "Attivo/Non attivo",
            "add": "Aggiungere",
            "addCategory": "Aggiungi categoria",
            "selectCategory": "Seleziona la categoria",
            "close": "Vicina",
            "publish": "Pubblica",
            "publishProductData": "Invia a Sofon",
            "export": "Esportare",
            "new": "Nuovo",
            "delete": "Elimina",
            "refresh": "Aggiorna",
            "create": "Crea",
            "proCosExport": "ProCos Esportazione",
            "pcsExport": "PCS Esportazione",
            "submit": "Invia"
        },
        "tooltip": {
            "edit": "Modificare",
            "view": "Visualizzazione",
            "reset": "Ripristina",
            "publishProductDataEnabled": "I dati presenti nell'ambito del Master e pubblicati saranno condivisi.",
            "publishProductDataDisabled": "Disabilitato perché il prodotto è inattivo in Master."
        },
        "footer": {
            "env": "Env",
            "release": "R",
            "sprint": "SP",
            "build": "Costruire",
            "branch": "Ramo",
            "date": "Data"
        },
        "labels": {
            "selectCategoryType": "Seleziona un tipo di categoria",
            "searchMultiNumericCategory": "Cerca categoria multi-numerica",
            "search": "Ricerca",
            "recordsPerPage": "Archivio",
            "workItem": "Oggetto da lavoro",
            "searchproduct": "Cerca prodotto",
            "language": "Seleziona la lingua",
            "feature": "Caratteristica",
            "option": "Opzione",
            "type": "Tipa",
            "reset": "Ripristina i valori del prodotto",
            "flag": "Bandiera",
            "code": "Codice",
            "country": "Paese",
            "quote": "Richiesta di offerta",
            "quoteSymbol": "Q",
            "saveStatus": "Salva",
            "expandAll": "Espandi tutto",
            "collapseAll": "Comprimi tutto",
            "masterProperties": "Proprietà principali",
            "productProperties": "Proprietà del prodotto",
            "categories": "Categorie",
            "unassigned": "Non assegnato",
            "assigned": "Assegnata",
            "defaultAssignment": "Assegnato per impostazione predefinita",
            "refresh": "Aggiorna",
            "procos": "ProCoS",
            "pdm": "PDM",
            "product": "Prodotto",
            "RuleCreationFailed": "Tutta la creazione della regola non è riuscita.",
            "standard": "Standard",
            "multiNumeric": "Multi-numerico",
            "multiNumericManagement": "Gestione multi-numerica",
            "manage": "Maneggio",
            "yes": "Sì",
            "no": "No",
            "isActive": "Attivo",
            "isLocal": "È locale",
            "name": "Nome",
            "status": "Stato",
            "others": "Altre",
            "multiNumericAction": "{{Action}} Funzione multinumerica",
            "createdOn": "Creato il",
            "modifiedOn": "Modificato il",
            "createdBy": "Creato da",
            "modifiedBy": "Modificato da",
            "active": "Attivo",
            "inActive": "Non attivo",
            "propertyCode": "Codice proprietà",
            "associationType": "Tipo di associazione",
            "featureCode": "Codice caratteristica",
            "optionCode": "Codice opzione",
            "action": "Azione",
            "oldValue": "Valore precedente",
            "newValue": "Nuovo valore",
            "startDate": "Data di inizio",
            "endDate": "Data di fine",
            "history": "Storia",
            "properties": {
                "ACO": "Codice alternativo",
                "AGC": "Gruppo di articoli",
                "ASC": "Codici associati",
                "CHT": "Tipo di canale",
                "CON": "Consumatore",
                "DVI": "Consegna tramite",
                "GRD": "È custodito",
                "HDE": "Nascondere",
                "ICO": "Catalogo solo per bambini",
                "IPR": "Il prezzo è rilevante",
                "ITY": "Tipo di articolo",
                "MLE": "Lunghezza massima",
                "OPT": "È opzionale",
                "ORI": "Istruzioni per l'ordine",
                "PAT": "Tipo di prodotto",
                "PCFD": "Stampa su CFD",
                "PMA": "Disponibilità del mercato ProCos",
                "RCI": "Identificatore del catalogo di rilascio",
                "REO": "È di sola lettura",
                "RMA": "Regole disponibili sul mercato",
                "RTY": "Tipo di riferimento",
                "SCN": "Nome della caratteristica SAP",
                "SCV": "Valore della caratteristica SAP",
                "SRI": "Il servizio è rilevante?",
                "ERO": "Organizzazione per la responsabilità ingegneristica"
            },
            "selectAll": "Seleziona tutto",
            "consumers": "Consumatori"
        },
        "home": {
            "header": "Selezione del modello del prodotto"
        },
        "dialogBox": {
            "error": "Errore",
            "save": "Salva",
            "reset": "Reimposta",
            "revert": "Ripristina",
            "unsavedChanges": "Avviso - Modifiche non salvate",
            "success": "successo",
            "delete10Items": "Solo 10 record eliminabili alla volta",
            "confirm": "Confermare {{action}}"
        },
        "messages": {
            "logoutMessage": "L'utente è disconnesso. Accedi nuovamente all'applicazione.",
            "unauthenticated": "User is not logged in. Please login. If problem persists, please contact your administrator.",
            "browserNotSupported": "Browser not supported",
            "browserNotSupportedMessage": "You are using a browser or browser version that is not officially supported.<1/><1/>You can continue to use the application or use one of the latest version of the supported browser for best experience.",
            "supportedBrowsers": "Supported browsers: ",
            "downloadMessage": "{{filename}} a è stato scaricato con successo",
            "noSearchRecords": "Nessun record trovato per '{{searchValue}}'",
            "noDataFound": "Nessun dato trovato.",
            "noDataFoundForCriteria": "Nessun dato disponibile per i criteri specificati.",
            "error": {
                "403": "Non hai accesso. Si prega di contattare l'amministratore.",
                "ERR_NETWORK": " Errore di rete: impossibile elaborare la richiesta, prova a salvare nuovamente i dati.",
                "WiInvalid": "L'elemento di lavoro selezionato non è valido! Seleziona un altro elemento di lavoro o creane uno nuovo.",
                "E_RUL_VAL_101": "Dati ProCos non trovati",
                "E_PRD_VAL_101": "Consumatori non validi: {{consumers}}"
            },
            "pdm": {
                "noPropertiesFound": "Nessuna proprietà trovata"
            },
            "feature": {
                "confirmDelete": "Sei sicuro di voler eliminare?"
            },
            "category": {
                "selectCategory": "Seleziona una categoria",
                "categoryAlreadyExist": "La sequenza o la categoria esistono già",
                "confirm": "Confermare",
                "confirmDelete": "Sei sicuro di voler eliminare la categoria?",
                "confirmCleanEmptySection": "Abschnitte ohne Funktion werden entfernt.",
                "unsavedChanges": "Warnung - nicht gespeicherte Änderungen",
                "discardChanges": "Nicht gespeicherte Änderungen werden verworfen. Möchten Sie fortfahren?",
                "savedSuccessfully": "Vista principale salvata correttamente",
                "noFeatureAssigned": "Nessuna funzione assegnata !",
                "saveToremoveObsoleteFeature": "Ci sono Funzionalità obsolete e lui deve salvare",
                "multiNumericWarning": "È possibile aggiungere solo famiglie di feature numeriche.",
                "multiNumericReadError": "Funzionalità non trovata",
                "multiNumericMinValidationError": "Sono richiesti almeno {{minLength}} caratteri.",
                "multiNumericMaxValidationError": "Sono consentiti al massimo {{maxLength}} caratteri.",
                "searchLimitWarning": "{{limit}}/{{total}} risultati sono mostrati. Affina i criteri di ricerca per restringere i risultati"
            },
            "submit": {
                "general": "Le modifiche sono state salvate con successo!",
                "new": "Desideri salvare le informazioni ProCoS in <1>Nuovo elemento di lavoro</1> ?",
                "exist": "Desideri salvare le informazioni ProCoS nell'oggetto di lavoro - <1>{{workItemName}} </1> ?",
                "success": "Modifiche salvate correttamente in WorkItem - <1>{{workItemName}} </1>",
                "error": "Salvataggio non riuscito !",
                "reset": "Desideri reimpostare i ProCo di funzionalità/opzione con ProCo a livello di prodotto?",
                "resetAll": "Vuoi reimpostare i ProCo di tutte le funzionalità/opzioni con ProCo a livello di prodotto?",
                "revert": "Desideri ripristinare le modifiche apportate all'elemento di lavoro corrente - <1>{{workItemName}} </1> ?",
                "failedEffectivities": "Fallito (Attivo / Inattivo): Le seguenti funzionalità / opzioni non possono essere elaborate.",
                "AllEffectivityFailed": "Tutti gli aggiornamenti dell'efficacia non sono riusciti.",
                "RulesSaved": "Regole salvate con successo.",
                "EffectivitySaved": "Efficacia salvata correttamente.",
                "DeleteRequest": "Richiesta eliminazione fallita",
                "DeleteRequestSuccess": "Eliminate con successo ({{length}}) funzionalità multiNumeriche : {{list}}"
            },
            "cancel": {
                "workitemWarning": "Sei sicuro di voler passare all'oggetto di lavoro - <1>{{workItemName}} </1> ?",
                "homeWarning": "Sei sicuro di voler navigare da questa pagina?",
                "featureChangeWarning": "Sei sicuro di voler passare a un'altra funzionalità?",
                "undoPropAssociationWarning": "Sei sicuro di voler annullare le modifiche?"
            },
            "refresh": "Le modifiche attuali andranno perse durante l'aggiornamento. Desideri procedere?",
            "inActiveProduct": {
                "header": "Prodotto inattivo",
                "message": "Non sono consentite modifiche all'associazione del mercato"
            },
            "saveProcos": {
                "rulesFailedTopic": "Elaborazione fallita",
                "rulesFailed": "Pagina {{pageNo}} : {{rule}} regole <ruleIcon/>, {{property}} proprietà <propertyIcon/>",
                "batchStatus": "Salva ProCos - {{completedBatchesCount}} lotto(i) completato(i) su {{totalBatchCount}} lotto(i).",
                "batchSuccess": "Tutti i lotto(i) riusciti",
                "batchFailed": "Tutti i lotto(i) falliti",
                "batchPartialSuccess": "Uno o più lotti non sono riusciti"
            },
            "success": {
                "create": "Creato con successo!",
                "update": "Aggiornato con successo!"
            },
            "fail": {
                "create": "Creazione fallita!",
                "update": "Aggiornamento fallito!",
                "get": "Si è verificato un errore. Impossibile recuperare i dettagli!"
            }
        },
        "request": {
            "success": "Richiesta effettuata con successo",
            "failed": "Richiesta non riuscita"
        }
    }
}